import { useSnackbar } from "notistack";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Box, Divider, Typography } from "@mui/material";

import { backendPost } from "../../../services/dataService.js";
import Form from "../../../components/Form/Form.jsx";
import FormTextField from "../../../components/Form/FormTextField.jsx";
import SubmitButton from "../../../components/Form/SubmitButton.jsx";
import TwoFactorSettings from "../../../components/auth/TwoFactorSettings.jsx";
import {
  passwordChangeSchema,
  passwordHelperText,
} from "../../../utils/passwordValidation.js";

const validationSchema = yup.object(passwordChangeSchema);

const SecuritySettingsSection = () => {
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async (data, formMethods) => {
    let success = false;
    await backendPost("data/user/change-password", {
      toSend: data,
      label: "Passwort ändern",
      enqueueSnackbar,
      setError: formMethods.setError,
      successMessage: "Passwort erfolgreich geändert.",
      onSuccess: () => {
        // For the password form, we don't pass the new values back to reset().
        // Instead, we call it with no arguments to reset to the initial empty state.
        formMethods.reset();
        success = true;
      },
    });
    return success;
  };

  return (
    <Box>
      {/* Password Change Section */}
      <Box>
        <Typography variant="h3" sx={{ mb: 2 }}>
          Passwort ändern
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Geben Sie hier Ihr neues Passwort ein, um es zu ändern. Aus
          Sicherheitsgründen und um Tippfehler zu vermeiden müssen Sie das neue
          Passwort bestätigen.
        </Typography>
        <Form
          onSubmit={onSubmit}
          resolver={yupResolver(validationSchema)}
          defaultValues={{
            current_password: "",
            new_password: "",
            new_password_confirmation: "",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormTextField
              name="current_password"
              label="Aktuelles Passwort"
              type="password"
            />
            <FormTextField
              name="new_password"
              label="Neues Passwort"
              type="password"
              helperText={passwordHelperText.requirements}
            />
            <FormTextField
              name="new_password_confirmation"
              label="Neues Passwort bestätigen"
              type="password"
            />
            <Box>
              <SubmitButton>Passwort ändern</SubmitButton>
            </Box>
          </Box>
        </Form>
      </Box>

      <Divider sx={{ my: 5 }} />

      {/* Two-Factor Authentication Section */}
      <Box>
        <TwoFactorSettings />
      </Box>
    </Box>
  );
};

export default SecuritySettingsSection;
